import React, { useState, useEffect } from "react";
import axios from "../api/api";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";
import "./Checkout.css";

const Checkout = () => {
    const [cartItems, setCartItems] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [discountCode, setDiscountCode] = useState("");
    const [discountValue, setDiscountValue] = useState(0);
    const [finalPrice, setFinalPrice] = useState(0);
    const [addresses, setAddresses] = useState([]);
    const [selectedAddressId, setSelectedAddressId] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    useEffect(() => {
        const fetchCartAndAddresses = async () => {
            try {
                const response = await axios.get("/carts");
                setCartItems(response.data.items);
                setTotalPrice(response.data.totalPrice);
                setFinalPrice(response.data.totalPrice);
                setAddresses(response.data.addresses);

                // Nếu có địa chỉ mặc định, tự động chọn
                const defaultAddress = response.data.addresses.find((address) => address.isDefault);
                if (defaultAddress) {
                    setSelectedAddressId(defaultAddress._id);
                }
            } catch (error) {
                console.error("Error fetching cart and addresses:", error);
            }
        };

        fetchCartAndAddresses();
    }, []);

    const handleApplyDiscount = async () => {
        if (!discountCode) {
            setError("Vui lòng nhập mã giảm giá.");
            return;
        }
        try {
            const response = await axios.post("/orders/apply", {
                code: discountCode,
                totalAmount: totalPrice,
            });

            setDiscountValue(response.data.discountValue);
            setFinalPrice(totalPrice - response.data.discountValue);
            setError("");
            setSuccess(`Mã giảm giá "${discountCode}" đã được áp dụng.`);
        } catch (error) {
            setError(
                error.response?.data?.message || "Mã giảm giá không hợp lệ hoặc đã hết hạn."
            );
        }
    };

    const handlePlaceOrder = async () => {
        if (!selectedAddressId) {
            setError("Vui lòng chọn địa chỉ nhận hàng.");
            return;
        }
        const isConfirmed = window.confirm("Bạn có chắc chắn đặt đơn hàng này?");
        if (!isConfirmed) {
            return; // Người dùng chọn "Hủy"
        }
        try {
            const response = await axios.post("/orders", {
                items: cartItems.map((item) => ({
                    productId: item.productId,
                    quantity: item.quantity,
                    price: item.price,
                })),
                totalAmount: finalPrice,
                discount: {
                    code: discountCode,
                    discountValue: discountValue,
                },
                deliveryAddressId: selectedAddressId,
            });

            setSuccess("Đơn hàng của bạn đã được đặt thành công vui lòng chờ chúng tôi liên hệ giao hàng.");
            // Xóa giỏ hàng
            await axios.post('/carts/checkout');

            setError("");
        } catch (error) {
            setError("Đã xảy ra lỗi khi đặt hàng. Vui lòng thử lại.");
        }
    };

    const handleAddressChange = (addressId) => {
        setSelectedAddressId(addressId);
    };

    return (
        <Layout>
            <div className="checkout-container">
                <h1>Thanh Toán</h1>

                {cartItems.length === 0 ? (
                    <p>Giỏ hàng của bạn hiện đang trống.</p>
                ) : (
                    <>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Sản phẩm</th>
                                    <th>Số lượng</th>
                                    <th>Đơn giá</th>
                                    <th>Thành tiền</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cartItems.map((item) => (
                                    <tr key={item.productId}>
                                        <td>{item.productName}</td>
                                        <td>{item.quantity}</td>
                                        <td>{item.price.toLocaleString()} VND</td>
                                        <td>{(item.price * item.quantity).toLocaleString()} VND</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="checkout-summary">
                            <h4>Tổng tiền: {totalPrice.toLocaleString()} VND</h4>
                            <div className="discount">
                                <input
                                    type="text"
                                    placeholder="Nhập mã giảm giá"
                                    value={discountCode}
                                    onChange={(e) => setDiscountCode(e.target.value)}
                                    className="form-control"
                                />
                                <button onClick={handleApplyDiscount} className="btn btn-primary">
                                    Áp dụng
                                </button>
                            </div>
                            {discountValue > 0 && (
                                <h4>Giảm giá: -{discountValue.toLocaleString()} VND</h4>
                            )}
                            <h4>Thành tiền: {finalPrice.toLocaleString()} VND</h4>
                        </div>

                        <div className="address-section">
                            <h4>Chọn địa chỉ giao hàng</h4>
                            {addresses && addresses.length > 0 ? ( // Kiểm tra addresses tồn tại và không rỗng
                                <div className="address-list">
                                    {addresses.map((address) => (
                                        <div key={address._id} className="address-item">
                                            <input
                                                type="radio"
                                                name="selectedAddress"
                                                value={address._id}
                                                checked={selectedAddressId === address._id}
                                                onChange={() => handleAddressChange(address._id)}
                                            />
                                            <label>
                                                {address.title}: {address.detailedAddress}, {address.wardName},{" "}
                                                {address.districtName}, {address.provinceName}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>
                                    Bạn chưa có địa chỉ nhận hàng.{" "}
                                    <Link to="/profile" className="btn btn-link">
                                        Hãy cập nhật địa chỉ nhận hàng
                                    </Link>
                                </p>
                            )}
                        </div>


                        {error && <p className="text-danger">{error}</p>}
                        {success && <p className="text-success">{success}</p>}

                        <div className="checkout-actions">
                            <Link to="/products" className="btn btn-secondary">
                                Tiếp tục mua hàng
                            </Link>
                            {addresses.length > 0 && !success && (
                                <button onClick={handlePlaceOrder} className="btn btn-primary">
                                    Đặt hàng
                                </button>
                            )}
                            {success && (
                                <Link to="/orders" className="btn btn-info">
                                    Theo dõi tình trạng đơn hàng
                                </Link>
                            )}
                        </div>
                    </>
                )}
            </div>
        </Layout>
    );
};

export default Checkout;
